import { PlayerAction } from "./enums"

const MOVE_KEYS: { [key: string]: PlayerAction } = {
  "1": PlayerAction.TOGGLE_FOW,
  "2": PlayerAction.ADD_XP,
  "3": PlayerAction.ADD_ELIXIR,
  "4": PlayerAction.UNLOCK_ALL_ITEMS,
  "9": PlayerAction.COMPLETE_TAPESTRY,
  "0": PlayerAction.DELETE_LOCALSTORAGE,

  H: PlayerAction.GO_HOME,
  h: PlayerAction.GO_HOME,

  " ": PlayerAction.CYCLE_OPTIC, // Space Bar
  Escape: PlayerAction.CLOSE_POPUP,
  ArrowUp: PlayerAction.MOVE_UP,
  W: PlayerAction.MOVE_UP,
  w: PlayerAction.MOVE_UP,
  ArrowLeft: PlayerAction.MOVE_LEFT,
  A: PlayerAction.MOVE_LEFT,
  a: PlayerAction.MOVE_LEFT,
  ArrowDown: PlayerAction.MOVE_DOWN,
  S: PlayerAction.MOVE_DOWN,
  s: PlayerAction.MOVE_DOWN,
  ArrowRight: PlayerAction.MOVE_RIGHT,
  d: PlayerAction.MOVE_RIGHT,
  D: PlayerAction.MOVE_RIGHT,
  I: PlayerAction.INTERACT,
  i: PlayerAction.INTERACT,
  X: PlayerAction.USE_ELIXIR,
  x: PlayerAction.USE_ELIXIR,
  G: PlayerAction.USE_GIZMO,
  g: PlayerAction.USE_GIZMO,
  b: PlayerAction.BIND_PIGMENT,
  B: PlayerAction.BIND_PIGMENT,
  L: PlayerAction.VIEW_LOADOUT,
  l: PlayerAction.VIEW_LOADOUT,
  y: PlayerAction.CONFIRM_YES,
  Y: PlayerAction.CONFIRM_YES,
  n: PlayerAction.CONFIRM_NO,
  N: PlayerAction.CONFIRM_NO,
}

function handleInput(event: KeyboardEvent): PlayerAction {
  if (event.key in MOVE_KEYS) {
    return MOVE_KEYS[event.key]
  }

  return PlayerAction.NONE
}

function isMotion(action: PlayerAction): boolean {
  return (
    action == PlayerAction.MOVE_LEFT ||
    action == PlayerAction.MOVE_RIGHT ||
    action == PlayerAction.MOVE_UP ||
    action == PlayerAction.MOVE_DOWN ||
    action == PlayerAction.ROTATE_COUNTER_CLOCKWISE ||
    action == PlayerAction.ROTATE_CLOCKWISE
  )
}

function isTestingAction(action: PlayerAction): boolean {
  return (
    action == PlayerAction.TOGGLE_FOW ||
    action == PlayerAction.ADD_XP ||
    action == PlayerAction.ADD_ELIXIR ||
    action == PlayerAction.UNLOCK_ALL_ITEMS ||
    action == PlayerAction.COMPLETE_TAPESTRY ||
    action == PlayerAction.DELETE_LOCALSTORAGE
  )
}

export { handleInput, isMotion, isTestingAction }
